import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";

import { getViewReturnsDetails, SurViewReturnsDetailsModel, ViewReturnsDetailsParameter } from "@tSurya/Services/ViewReturnsDetailsService";

import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

type HandlerType = CustomApiHandler<ViewReturnsDetailsParameter, SurViewReturnsDetailsModel>;

export const DispatchBeginViewReturnsDetails: HandlerType = props => {
    props.dispatch({
        type: "Custom/ViewReturnsDetailsService/BeginLoadViewReturnsDetails",
    });
};
export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};
export const StoreAPIParameterData: HandlerType = props => {
    if (!props.parameter) {
        return;
    }
    props.dispatch({
        type: "Custom/ViewReturnsDetailsService/CompletedLoadViewReturnsDetails",
        searchparameter: props.apiParameter,
    });
};
export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getViewReturnsDetails(props.apiParameter);
};

export const DispatchCompleteViewReturn: HandlerType = props => {
    if (!props.apiResult) {
        return;
    }
    props.dispatch({
        type: "Custom/ViewReturnsDetailsService/CompletedLoadViewReturnsDetails",
        result: props.apiResult,
    });
};

export const chain = [
    DispatchBeginViewReturnsDetails,
    PopulateApiParameter,
    StoreAPIParameterData,
    RequestDataFromApi,
    DispatchCompleteViewReturn,
];

const loadViewReturnsDetails = createHandlerChainRunner(chain, "loadViewReturnsDetails");
export default loadViewReturnsDetails;
